import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Form, Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { getProjectByIdAction, updateProjectAction } from '../../store/reducers/project';
import { accountAuthInfoPagingAction } from '../../store/reducers/account';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { ID_EMPTY } from '../../utils/define';

const ProjectEdit = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const { listAccount } = useSelector((state) => state.account);
    const { item } = useSelector((state) => state.project);

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState(0);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [actualEndDate, setActualEndDate] = useState('');
    const [selectedMemberIds, setSelectedMemberIds] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        dispatch(accountAuthInfoPagingAction({ pageIndex: 1, pageSize: 1000 }));
        dispatch(getProjectByIdAction(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (item && String(item.id || '') === String(id)) {
            setName(item.name || '');
            setDescription(item.description || '');
            setStatus(item.status || 0);
            setStartDate(item.startDate ? item.startDate.split('T')[0] : '');
            setEndDate(item.endDate ? item.endDate.split('T')[0] : '');
            setActualEndDate(item.actualEndDate ? item.actualEndDate.split('T')[0] : '');
            
            // Map members safely
            if (item.members && Array.isArray(item.members)) {
                setSelectedMemberIds(item.members.map(m => m.userId || m.id).filter(id => id));
            } else {
                setSelectedMemberIds([]);
            }
        }
    }, [item, id]);

    const memberOptions = listAccount
        .filter(item => {
            const roles = item.account?.roles || item.account?.Roles || [];
            return roles.some(r => (r.name || r.Name) === 'APP_KPI_C9_ACCESS');
        })
        .map(item => {
            const id = item.accountId || item.account?.id || item.account?.Id;
            const username = item.account?.username || item.account?.Username;
            
            const lastName = item.lastName || '';
            const middleName = item.middleName || '';
            const firstName = item.firstName || '';
            const fullName = `${lastName} ${middleName} ${firstName}`.trim().replace(/\s+/g, ' ');

            return {
                value: id,
                label: fullName ? `${fullName} (${username})` : username
            };
        });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim()) {
            toast.error('Vui lòng nhập tên dự án');
            return;
        }

        const model = {
            id: id,
            data: {
                name: name.trim(),
                description: description.trim(),
                status: Number(status),
                startDate: startDate || null,
                endDate: endDate || null,
                actualEndDate: actualEndDate || null,
                memberIds: selectedMemberIds
            }
        };

        try {
            setSubmitting(true);
            await dispatch(updateProjectAction(model)).unwrap();
            toast.success('Cập nhật dự án thành công');
            history.push('/project');
        } catch (err) {
            toast.error('Cập nhật dự án thất bại');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Sửa dự án</Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>Tên dự án <span className="text-danger">*</span></Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                type="text"
                                placeholder="Nhập tên dự án"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>


                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>Ngày bắt đầu</Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </Col>
                        <Form.Label column sm={2}>Ngày kết thúc dự kiến</Form.Label>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </Col>
                    </Form.Group>


                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>Mô tả</Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>Người tham gia</Form.Label>
                        <Col sm={10}>
                            <Select
                                isMulti
                                options={memberOptions}
                                placeholder="Chọn người tham gia..."
                                value={memberOptions.filter(opt => selectedMemberIds.includes(opt.value))}
                                onChange={(selected) => setSelectedMemberIds(selected ? selected.map(x => x.value) : [])}
                                classNamePrefix="select"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                        <Col sm={{ span: 10, offset: 2 }}>
                            <ButtonGroup>
                                <Button type="submit" variant="primary" disabled={submitting}>
                                    {submitting ? 'Đang lưu...' : 'Cập nhật'}
                                </Button>
                                <Button variant="secondary" onClick={() => history.push('/project')} disabled={submitting}>
                                    Hủy
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default ProjectEdit;
